import { render, staticRenderFns } from "./PatientFormDynamicList.vue?vue&type=template&id=70a1a6fb&"
import script from "./PatientFormDynamicList.vue?vue&type=script&lang=js&"
export * from "./PatientFormDynamicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports